import React from 'react';
import { Search, Filter } from 'lucide-react';

const UtilisateurFilters = ({ filters, onFilterChange }) => {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Recherche */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Rechercher (nom, email, téléphone...)"
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>

        {/* Filtre par statut */}
        <div>
          <select
            value={filters.status}
            onChange={(e) => onFilterChange('status', e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="">Tous les statuts</option>
            <option value="active">Actifs</option>
            <option value="inactive">Inactifs</option>
          </select>
        </div>

        {/* Tri */}
        <div>
          <select
            value={filters.ordering}
            onChange={(e) => onFilterChange('ordering', e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          >
            <option value="-date_joined">Plus récents</option>
            <option value="date_joined">Plus anciens</option>
            <option value="username">Nom (A-Z)</option>
            <option value="-username">Nom (Z-A)</option>
            <option value="first_name">Prénom (A-Z)</option>
            <option value="-first_name">Prénom (Z-A)</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default UtilisateurFilters;
